"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requiredType = exports.requiredDefined = exports.required = void 0;
/**
 * Helper like assert but work on web and nodejs
 * @param assertion
 * @param message
 */
exports.required = (assertion, message) => {
    if (assertion !== true) {
        console.error('Error from required:', message);
        throw message;
    }
};
/**
 * Requires variable to be defined
 * @param variable
 * @param message
 */
exports.requiredDefined = (variable, message) => {
    return exports.required(variable !== null && variable !== undefined, message);
};
/**
 * Required type of variable
 * @param variable
 * @param {string} type
 * @param message
 */
exports.requiredType = (variable, type, message) => {
    if (type === 'array') {
        return exports.required(Array.isArray(variable), message);
    }
    return exports.required((typeof variable).toString() === type, message);
};
//# sourceMappingURL=required.js.map